const GroupType = Object.freeze({
  RETAIL: "RETAIL",
  NON_RETAIL: "NON_RETAIL",
  UNKNOWN: "UNKNOWN",
});

export default GroupType;
